import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Autoplay } from 'swiper/modules';


document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.hero-slider .swiper');

  // Labels for pagination buttons (Finnish)
  const labels = [
    "Projektinjohto",
    "Valvonta",
    "Turvallisuus ja riskienhallinta",
    "Asiantuntijapalvelut ja kehitystehtävät"
  ];

  const swiper = new Swiper(swiperEl, {
    modules: [Navigation, Pagination, Keyboard, Autoplay],
    loop: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        const safeLabel = labels[index] || `Slide ${index + 1}`;
        return `<button type="button" role="tab" aria-controls="slide-${index}" aria-selected="false" class="${className}">${safeLabel}</button>`;
      },
    },
    on: {
      init() {
        updatePaginationAria(this);
      },
      slideChange() {
        updatePaginationAria(this);
      }
    }
  });

  // Assign IDs to slides for accessibility
  document.querySelectorAll('.swiper-slide').forEach((el, idx) => {
    el.id = `slide-${idx}`;
  });

  // Accessibility helper
  function updatePaginationAria(swpr) {
    const bullets = document.querySelectorAll('.swiper-pagination .swiper-pagination-bullet');
    bullets.forEach((b, i) => {
      const active = i === swpr.realIndex; // ✅ Use realIndex instead of activeIndex
      b.setAttribute('aria-selected', active ? 'true' : 'false');
      b.classList.toggle('swiper-pagination-bullet-active', active);
    });
  }

  // Keyboard arrow key navigation on pagination buttons
  const paginationEl = document.querySelector('.hero-slider__pagination');
  paginationEl?.addEventListener('keydown', (e) => {
    const bullets = Array.from(document.querySelectorAll('.swiper-pagination .swiper-pagination-bullet'));
    const idx = bullets.indexOf(document.activeElement);
    if (idx === -1) return;
    if (['ArrowRight', 'ArrowDown'].includes(e.key)) {
      e.preventDefault();
      const next = bullets[idx + 1] || bullets[0];
      next.focus();
      next.click();
    } else if (['ArrowLeft', 'ArrowUp'].includes(e.key)) {
      e.preventDefault();
      const prev = bullets[idx - 1] || bullets[bullets.length - 1];
      prev.focus();
      prev.click();
    }
  });

  // Ensure clicked buttons stay focused
  paginationEl?.addEventListener('click', (e) => {
    if (e.target.classList.contains('swiper-pagination-bullet')) {
      e.target.focus();
    }
  });
});
